export default __webpack_public_path__ + "static/media/logo123.cd734d1c.png";